<template>
  <v-form ref="form" class="">

    <BaseUtil ref="util" :pageLoading="pageLoading" />

    <div class="title my-3 d-block d-md-none" id="purchaseSummary">
      <div>
        Venda: <b v-if="entry.totalPrice" class="green--text mr-4"> {{ entry.totalPrice | formatCurrency }} </b> <b v-else
          class="black--text mr-4">R$ 0,00</b>
      </div>
      <div>
        Recebimentos: <b v-if="entry.totalPrice"
          :class="entry.totalPrice == saleTotalPayment ? 'green--text' : 'red--text'"> {{ saleTotalPayment |
          formatCurrency}} </b> <b v-else class="black--text mr-4">R$ 0,00</b>
      </div>
    </div>

    <v-tabs>
      <v-tab>Geral</v-tab>
      <v-tab v-if="entry.fiscalDocumentType != 'NFCe'">Entrega/Frete</v-tab>
      <v-tab>Recebimentos</v-tab>
      <v-tab v-if="!extraData.accountContext.accountPermissions.isAltavenda">Planejamentos</v-tab>

      <v-spacer></v-spacer>
      <div class="title mt-3 d-none d-md-block" id="saleSummary">
        Total da Venda: <b v-if="entry.totalPrice" class="green--text mr-4"> {{ entry.totalPrice | formatCurrency }} </b>
        <b v-else class="black--text mr-4">R$ 0,00</b>
        Total de Recebimentos: <b v-if="entry.totalPrice"
          :class="entry.totalPrice == saleTotalPayment ? 'green--text' : 'red--text'"> {{ saleTotalPayment |
          formatCurrency}} </b> <b v-else class="black--text mr-4">R$ 0,00</b>
      </div>


      <v-tab-item>
        <v-row>
          <v-col cols="12" sm="3">
            <MaskedTextField v-bind="getObject('code')" :inputData.sync="entry.code" mask-type="integer" label="Código"
              readonly :disabled="readOnly" autocomplete="off" />
          </v-col>

          <v-col cols="12" sm="9">
            <v-autocomplete v-model="entry.customerId" v-bind="getObject('customerId')" label="Cliente"
              :items="extraData.accountContext.allCustomers" item-value="id" item-text="name" :disabled="readOnly"
              autocomplete="off" clearable @click:clear="$nextTick(() => entry.customerId = null)">
              <template v-slot:append-outer>
                <PersonNew :inlineAddButton="true" :isCustomer="true" @entry-created="personCreated"
                  modelNameSingular="Pessoa" />
              </template>
            </v-autocomplete>
          </v-col>

           <v-col cols="12" sm="12" md="4" v-if="!extraData.accountContext.accountPermissions.isAltavenda">
              <v-text-field v-model="entry.plate" v-bind="getObject('plate')" :label="'Placa'" autocomplete="off"
                :disabled="readOnly" />
            </v-col>

          

          <v-col cols="12" sm="12" md="4" v-if="extraData.accountContext.accountPermissions.isAltavenda">
            <v-autocomplete v-model="entry.paymentConditionRuleId" v-bind="getObject('paymentConditionRuleId')" label="Condição de pagamento"
              :items="extraData.accountContext.allPaymentConditionRules" item-value="id" item-text="name" :disabled="readOnly"
              autocomplete="off" clearable @click:clear="$nextTick(() => entry.paymentConditionRuleId = null)">
            </v-autocomplete>
          </v-col>

          <v-col cols="12" sm="6" md="4">
            <DateField :inputData.sync="entry.date" v-bind="getObject('date')" label="Data do Pedido"
              :hasTodayButton="true" :hasTodayDate="true" :disabled="readOnly" autocomplete="off" />
          </v-col>

          <v-col cols="12" sm="6" md="4">
            <TimeField :inputData.sync="entry.saleOrderTime" v-bind="getObject('saleOrderTime')" label="Hora do pedido"
              :hasNowButton="true" :hasNowTime="true" autocomplete="off" />
          </v-col>

          <v-col cols="12" sm="12" md="12">
            <v-autocomplete
              v-model="entry.cfopId"
              v-bind="getObject('cfopId')"
              label="Cfop"
              :items="extraData.accountContext.allCfops"
              item-value="id"
              item-text="text"
              :disabled="readOnly"
              autocomplete="off"
            >
            </v-autocomplete>
          </v-col>

        </v-row>

        
          
        

        <v-row>
          <v-col cols="12" class="">
            <SaleOrderProductIndex :saleOrderProducts="entry.dummyExitMovementItemsAttributes" :extras="extras"
              :saleTotalPrice.sync="productsTotalPrice" :readOnly="readOnly" :hasTableTitle="true"
              tableTitle="Produtos de Venda" />
          </v-col>

          <v-col cols="12" sm="6" md="2">
            <MaskedTextField v-bind="getObject('totalInsuranceValue')" :inputData.sync="entry.totalInsuranceValue"
              mask-type="currency" label="Seguro" prefix="R$" persistent-hint :disabled="readOnly" autocomplete="off">
              <template slot="prependMask">
                <v-icon>mdi-plus</v-icon>
              </template>
            </MaskedTextField>
          </v-col>

          <v-col cols="12" sm="6" md="2">
            <MaskedTextField v-bind="getObject('otherExpensesTotalValue')"
              :inputData.sync="entry.otherExpensesTotalValue" mask-type="currency" label="Outras Despesas" prefix="R$"
              persistent-hint :disabled="readOnly" autocomplete="off">
              <template slot="prependMask">
                <v-icon>mdi-plus</v-icon>
              </template>
            </MaskedTextField>
          </v-col>

          <v-col cols="12" sm="6" md="2">
            <MaskedTextField v-bind="getObject('totalCarriageValue')" :inputData.sync="entry.totalCarriageValue"
              mask-type="currency" label="Frete" prefix="R$" persistent-hint :disabled="readOnly"
              :key="totalCarriageValueKey" @change="totalCarriageValueKey += 1" autocomplete="off">
              <template slot="prependMask">
                <v-icon>mdi-plus</v-icon>
              </template>
            </MaskedTextField>
          </v-col>

          <v-col cols="12" sm="6" md="2">
            <MaskedTextField
            v-bind="getObject('totalDiscountValue')"
            :inputData.sync="entry.totalDiscountValue"
            mask-type="currency"
            label="Desconto"
            prefix="R$"
            persistent-hint
            :disabled="readOnly"
            autocomplete="off"
            :key="totalDiscountValueKey"
            >
              <template slot="prependMask">
                <v-icon>mdi-minus</v-icon>
              </template>
            </MaskedTextField>
          </v-col>

          <v-col cols="12" sm="12" md="4">
            <div class="title mt-3">
              <v-icon>mdi-equal</v-icon>
              Total da Venda:
              <b class="headline black--text font-weight-bold ml-2"> {{ saleTotalPrice | formatCurrency }} </b>
            </div>
          </v-col>

          <v-col cols="12" sm="6" md="4">
            <DateField :inputData.sync="entry.estimatedDeliveryDate" v-bind="getObject('estimatedDeliveryDate')"
              label="Data Estimada de Entrega" :hasTodayButton="true" :disabled="readOnly" autocomplete="off" />
          </v-col>

          <v-col cols="12">
            <v-textarea v-model="entry.observation" v-bind="getObject('observation')" label="Observações" outlined
              :disabled="readOnly" autocomplete="off"></v-textarea>
          </v-col>

        </v-row>
      </v-tab-item>

      <v-tab-item v-if="entry.fiscalDocumentType != 'NFCe'">
        <v-row>
          <v-col cols="12" sm="6">
            <v-autocomplete v-model="entry.carriageModalityId" v-bind="getObject('carriageModalityId')"
              label="Modalidade do Frete" :items="extraData.globalContext.allCarriageModalities" item-value="id"
              item-text="text" :disabled="readOnly" autocomplete="off" />
          </v-col>

          <!-- <v-col cols="12" sm="6">
            <v-autocomplete v-model="entry.carriageModalityId" v-bind="getObject('carriageModalityId')"
              label="Forma de entrega" :items="extraData.globalContext.allCarriageModalities" item-value="id"
              item-text="text" :disabled="readOnly" autocomplete="off" />
          </v-col> -->

          <v-col cols="12" sm="6" v-if="false">
            <v-autocomplete v-model="entry.carrierId" v-bind="getObject('carrierId')" label="Transportadora"
              :items="extraData.accountContext.allCarriers" item-value="id" item-text="name" :disabled="readOnly"
              autocomplete="off" />
          </v-col>

          <v-col cols="12" sm="6" md="3" v-if="false">
            <MaskedTextField v-bind="getObject('carrierLicensePlate')" :inputData.sync="entry.carrierLicensePlate"
              mask-type="plate" label="Placa" :disabled="readOnly" autocomplete="off" />
          </v-col>

          <v-col cols="12" sm="6" md="3" v-if="false">
            <v-autocomplete v-model="entry.carrierLicensePlateStateId" v-bind="getObject('carrierLicensePlateStateId')"
              label="UF Placa" :items="extraData.globalContext.allStates" item-value="id" item-text="shortName"
              :disabled="readOnly" autocomplete="off" />
          </v-col>

          <v-col cols="12" sm="6" md="3">
            <MaskedTextField v-bind="getObject('totalCarriageValue')" :inputData.sync="entry.totalCarriageValue"
              mask-type="currency" label="Valor do Frete" prefix="R$" persistent-hint :disabled="readOnly"
              :key="totalCarriageValueKey" @change="totalCarriageValueKey += 1" autocomplete="off" />
          </v-col>

           <!-- <v-col cols="12">
            <v-textarea v-model="entry.transportObservation" v-bind="getObject('transportObservation')" label="Observações de transporte" outlined
              :disabled="readOnly" autocomplete="off"></v-textarea>
          </v-col> -->

        </v-row>
      </v-tab-item>

      <v-tab-item>
        <v-row>
          <v-col cols="12" class="mt-3">
            <PaymentIndex :payments="entry.paymentsAttributes" :totalPayment.sync="saleTotalPayment"
              :paymentLimit="entry.totalPrice" :readOnly="readOnly" modelType="Sale"
              @installment-update="$emit('installment-update', $event)" :hasTableTitle="true"
              tableTitle="Recebimentos" />
          </v-col>
        </v-row>
      </v-tab-item>

      <v-tab-item v-if="!extraData.accountContext.accountPermissions.isAltavenda">
        <v-col cols="12">
          <PlanningIndex :indexItems="entry.operationsView" :saleOrder="entry" />
        </v-col>
      </v-tab-item>

    </v-tabs>

  </v-form>
</template>

<script>
import MultiSelect from "@shared_components/multi_select.vue";
import MaskedTextField from "@shared_components/masked_text_field.vue";
import DateField from "@shared_components/date_field.vue";
import SaleOrderProductIndex from "@models/sales/sale_orders/sale_order_products/index.vue";
import PaymentIndex from "@models/payments/index.vue";
import PersonNew from "@models/people/new.vue";
import PlanningIndex from "./planning_index.vue";
import BaseUtil from "@shared_components/base_util.vue";
import TimeField from "@shared_components/time_field.vue";

export default {
  data() {
    return {
      entryAttributes: {},
      saleTotalPayment: 0,
      productsTotalPrice: 0,
      totalCarriageValueKey: 0,
      totalDiscountValueKey: 0,
      pageLoading: false,
      extras: {},
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    MultiSelect: MultiSelect,
    MaskedTextField: MaskedTextField,
    SaleOrderProductIndex: SaleOrderProductIndex,
    DateField: DateField,
    PaymentIndex: PaymentIndex,
    PersonNew: PersonNew,
    BaseUtil: BaseUtil,
    PlanningIndex: PlanningIndex,
    TimeField: TimeField,
  },
  created() {
    // console.log("edit", this.entry);
    this.entryAttributes = this.setupEntryAttributes(this.entry);

    for (var payment in this.entry.paymentsAttributes) {
      if (this.entry.paymentsAttributes[payment] && this.entry.paymentsAttributes[payment].value && !this.entry.paymentsAttributes[payment]._destroy) {
        this.saleTotalPayment += this.entry.paymentsAttributes[payment].value;
      }
    }
    this.saleTotalPayment = _.round(this.saleTotalPayment, 2);

    if (this.entry.totalPrice) {
      this.productsTotalPrice = 0;
      for (var product in this.entry.dummyExitMovementItemsAttributes) {
        if (this.entry.dummyExitMovementItemsAttributes[product] && this.entry.dummyExitMovementItemsAttributes[product].price && !this.entry.dummyExitMovementItemsAttributes[product]._destroy) {
          this.productsTotalPrice += this.entry.dummyExitMovementItemsAttributes[product].price;
        }
      }
    }
    this.productsTotalPrice = _.round(this.productsTotalPrice, 2);

    
    if(this.extras.accountContext){
      
    }else{
      this.extras.accountContext = {};
    }
    
    this.extras.accountContext.accountPermissions = this.extraData.accountContext.accountPermissions;

    if(this.entry.customerId){
      this.extras.customerId = this.entry.customerId;
    }

    if(this.entry.paymentConditionRuleId){
      this.extras.paymentConditionRuleId = this.entry.paymentConditionRuleId;
    }

    // this.fiscalDocumentTypeChanged();
  },
  watch:{
    "entry.customerId": function(newValue, oldValue){
      this.extras.customerId = newValue;
      // console.log("extras form", this.extras);
    },
    "entry.paymentConditionRuleId": function(newValue, oldValue){
      this.extras.paymentConditionRuleId = newValue;
    },
    "entry.dummyExitMovementItemsAttributes": {
      handler: function (newValue, oldValue) {
        // console.log("entry edited !!!");
        //todo carregar informacoes dos storages novamente !!! ver se precisa!!!
        var total_discount = newValue.reduce( (accumulator, obj)=> accumulator + ((obj.discount) * obj.packagingQuantity),0 );
        console.log(total_discount);
        this.entry.totalDiscountValue = total_discount;

        try{
          console.log("pesos",newValue);
          var gross_weight = newValue.reduce( (accumulator, obj)=> accumulator + (obj.itemWeight.grossWeight * obj.packagingQuantity),0 );
          this.entry.grossWeight = gross_weight;
          console.log(gross_weight);

          var liquid_weight = newValue.reduce( (accumulator, obj)=> accumulator + (obj.itemWeight.liquidWeight * obj.packagingQuantity),0 );
          console.log(liquid_weight);
          this.entry.netWeight = liquid_weight;

        }catch(e){
          console.log("catch", this.entry);
          this.entry.netWeight = null;
          this.entry.grossWeight = null;
        }

        this.totalDiscountValueKey++;
      },
      deep: true,
    },
  },
  mounted() {
  },
  computed: {
    saleTotalPrice: function () {
      this.productsTotalPrice = this.productsTotalPrice ? this.productsTotalPrice : 0;
      this.entry.totalInsuranceValue = this.entry.totalInsuranceValue ? this.entry.totalInsuranceValue : 0;
      this.entry.otherExpensesTotalValue = this.entry.otherExpensesTotalValue ? this.entry.otherExpensesTotalValue : 0;
      this.entry.totalCarriageValue = this.entry.totalCarriageValue ? this.entry.totalCarriageValue : 0;
      this.entry.totalDiscountValue = this.entry.totalDiscountValue ? this.entry.totalDiscountValue : 0;


      this.entry.totalPrice = this.productsTotalPrice
        + this.entry.totalInsuranceValue
        + this.entry.otherExpensesTotalValue
        + this.entry.totalCarriageValue
        - this.entry.totalDiscountValue;
      return this.entry.totalPrice;
    }
  },
  methods: {
    getObject: function (element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function () {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function () {
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function () {
      this.$refs.form.resetValidation();
    },
    personCreated: function (person) {
      //testar pra ver se o tipo é supplier
      if (person.isCustomer) {
        this.extraData.accountContext.allCustomers.unshift(person);
        this.entry.customerId = person.id;
        this.entry.customer = person;
      } else {
        this.$refs.util.showErrorMessage("A pessoa cadastrada não é do tipo Cliente, por isso não irá aparecer na lista de clientes!");
      }
    },
    // fiscalDocumentTypeChanged: function() {
    //   this.entryAttributes.customerId.rules = [];
    //   this.entryAttributes.carriageModalityId.rules = [];
    //   if (this.entry.fiscalDocumentType != "NFCe") {
    //     this.entryAttributes.customerId.rules.push(this.requiredRule);
    //     this.entryAttributes.carriageModalityId.rules.push(this.requiredRule);
    //   }
    //   this.clearFields();
    // },
    clearFields: function () {
      this.forceRerender(this);
    },
  }
};
</script>

<style scoped>
#saleSummary {
  color: gray;
}
</style>
